import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// importing all the themes

import ThemeSeven from "../themes/theme-seven";



class MyRouts extends React.Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route exact path="/" component={ThemeSeven} />
          </Switch>
        </Router>
      </div>
    );
  }
}
export default MyRouts;